@if (status) {
  <div class="outer-container">
    {{ status | spaceBetweenCaps }}
  </div>
}
